import { ProgressBarBase, ProgressBarSkeleton } from './progress-bar.shared';
import type { ProgressBarProps } from './types';

export function ProgressBar(props: ProgressBarProps) {
  return (
    <ProgressBarBase
      {...props}
      accent={{ fill: 'bg-spark-progress-fill', active: 'bg-spark-progress-active' }}
    />
  );
}

ProgressBar.Skeleton = ProgressBarSkeleton;
